import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const EditIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M9 16.6096H17M13 1.94291C13.3536 1.58929 13.8332 1.39063 14.3333 1.39062C14.581 1.39062 14.8262 1.4394 15.0549 1.53416C15.2837 1.62892 15.4916 1.76781 15.6667 1.94291C15.8418 2.11801 15.9807 2.32587 16.0754 2.55465C16.1702 2.78342 16.219 3.02862 16.219 3.27624C16.219 3.52387 16.1702 3.76906 16.0754 3.99784C15.9807 4.22661 15.8418 4.43448 15.6667 4.60958L4.55556 15.7207L1 16.6096L1.88889 13.054L13 1.94291Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
